import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

import { PublishTikTokEntryScreen } from "@/features/publish-tiktok/screens/PublishTikTokEntryScreen";

const searchSchema = z.object({
  account: z.string().uuid().optional(),
});

export const Route = createFileRoute(
  "/_authenticated/(wonda)/_wonda/publish/tiktok/",
)({
  validateSearch: zodValidator(searchSchema),
  component: PublishTikTokEntryRoute,
});

function PublishTikTokEntryRoute() {
  const { account } = Route.useSearch();
  return <PublishTikTokEntryScreen selectedAccountId={account ?? null} />;
}
